import { KnowledgeInterface, QueryParams } from '../types/Knowledge';
import { apiUrls } from './apiUrls';
import { makeRequest } from './request';

class Knowledge implements KnowledgeInterface {
  readonly apiKey: string;

  constructor(apiKey: string) {
    this.apiKey = apiKey;
  }

  async add_knowledge(filePath: string, authorName: string, knowledgeName: string): Promise<any> {
    const formData = new FormData();
    formData.append('file', new File([filePath], 'file'));
    formData.append('author_name', authorName);
    formData.append('knowledge_name', knowledgeName);

    try {
      return await makeRequest(
        'POST',
        apiUrls.knowledge.upload,
        this.apiKey,
        {},
        null,
        null,
        formData
      );
    } catch (error) {
      console.error('Error uploading knowledge:', error);
    }
  }

  async get_knowledge_context_for_prompt(
    authorName: string,
    knowledgeName: string,
    promptText: string | null = null
  ): Promise<any> {
    const url = apiUrls.knowledge.context(authorName, knowledgeName);
    const queryParams: QueryParams = promptText ? { prompt: promptText } : {};
    try {
      return await makeRequest('GET', url, this.apiKey, queryParams);
    } catch (error) {
      console.error('Error fetching knowledge context:', error);
    }
  }
}

export default Knowledge;
